import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import UpdateAlert from './components/UpdateAlert';
import PageStructure from 'flarum/forum/components/PageStructure';
export default function addUpdateAlert() {
  extend(PageStructure.prototype, 'mainItems', function (items) {
    var _app$session$user;
    if ((_app$session$user = app.session.user) != null && _app$session$user.fofTermsPoliciesHasUpdate()) {
      items.add('updateAlert', m(UpdateAlert, null), 1001);
    }
  });
}